// 開発者モード設定
const state = {_devSettingMode: 0}

// アクション
const actions = {
  async updateDevSettingMode({ commit }, devSettingMode) {
    commit('setDevSettingMode', devSettingMode)
  }
}

// ミューテーション
const mutations = {
  setDevSettingMode(state, devSettingMode) {
    state['_devSettingMode'] = devSettingMode
  }
}

// ゲッター
const getters = {
  getDevSettingMode() {
    return state['_devSettingMode']
  }
}

export const devSettingStore = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/_store/dev-setting.module.js